import { render, staticRenderFns } from "./confirmpage.vue?vue&type=template&id=c66bdf2c"
import script from "./confirmpage.vue?vue&type=script&lang=js"
export * from "./confirmpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports